<div id="fullscreenMask" class="d-flex justify-content-center align-items-center" *ngIf="!isInFullscreenMode">
  <div class="full-screen-dlg">
    <img src="assets/img/rsm-blue-logo.png" alt="">
    <p>Welcome to RSM Online!</p>
    <button id="toFullScreen" class="btn btn-primary btn-block mt-4" (click)="toggleFullscreen()">Click Here To Enter Classroom</button>
    <p class="late-notify-msg" *ngIf="localUser.lateTimeInMinutes > 10">Class has started {{localUser.lateTimeInMinutes}} minutes ago!</p>
  </div>
</div>
